import styled, {css} from "styled-components";
import colors from "../../styles/colors";
import logoDesafioImg from "../../assets/logo-desafio.png";
import logoImg from "../../assets/logo.png";

export const Page = styled.section``;

export const Logo = styled.img.attrs({
  src: logoImg,
})``;

export const LogoDesafio = styled.img.attrs({
  src: logoDesafioImg,
})`
  margin-bottom: 48px;
`;

export const PageContent = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  max-width: 540px;
`;

export const LogoTitle = styled.h3`
  color: ${colors.yellow};
  text-transform: uppercase;
  font-size: 20px;
  margin: 14px auto 38px auto;
`;

export const MainContent = styled.div`
  text-align: center;
`;

export const Title = styled.h2`
  color: ${colors.green};
  font-size: 23px;
  margin: 0 auto;
  margin-bottom: 26px;
  text-transform: uppercase;
  max-width: 320px;
`;

export const DownloadLink = styled.a`
  color: ${colors.yellow};
  text-decoration: none;
  font-family: "Barlow", sans-serif;
  line-height: 20px;
  font-size: 20px;
  text-transform: uppercase;
  font-weight: bold;
  svg {
    color: ${colors.yellow};
    margin-right: 8px;
  }
`;

export const Paragraph = styled.p`
  font-size: 16px;
  max-width: ${(props) => `${props.maxWidth}px` || "100%"};
  margin: 0 auto;
  margin-bottom: 48px;
  span {
    font-weight: bold;
  }
`;

export const SignUpArea = styled.div`
  border-top: 1px solid #707070;
  max-width: 480px;
  margin: 90px auto;
  text-align: center;
`;

export const SignUpAreaTitle = styled.h3`
  font-size: 16px;
  margin-top: 26px;
  text-transform: uppercase;
`;

export const Price = styled.h1`
  font-weight: 400;
  color: ${colors.green};
  font-size: 50px;
  margin-top: 16px;
  margin-bottom: 48px;
`;

export const ButtonsArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 32px;

  @media screen and (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${colors.green};
  color: #000;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  padding: 16px 24px;
  transition: 300ms ease;

  &:hover {
    transform: scale(0.95);
  }

  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;

export const SignUpButton = styled(Button)``;
export const SignInButton = styled(Button)`
  background-color: ${colors.yellow};
`;
export const ImportantTitle = styled.div`
  font-family: "Barlow", sans-serif;
  color: ${colors.yellow};
  text-transform: uppercase;
  font-size: 23px;
  margin: 14px auto 38px auto;
  text-align: center;

  p{
    font-family: "Chivo", sans-serif;
    font-size: 16px;
    text-transform: none;
    color: #fff;
    margin-top: 16px;
  }
`;

export const ContainerSlide = styled.div`
  position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

  .swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: static;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.swiper-pagination {
    position: static;
    text-align: center;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    z-index: 10;
    margin-top: 16px;
}

.swiper-pagination .swiper-pagination-fraction {
    bottom: -35px;
    left: 0;
    width: 100%;
    color: #fff;
    text-align: center;
    }
`;

export const Slider = styled.div`
position: relative;
@media (max-width: 768px){
  img {
    width: 100%;
  }
}
@media (max-width: 425px){
  img {
    width: 100%;
  }
}
`;


export const Arrow = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 35px;
  height: 35px;
  color: #fff;
  border-radius: 45px;
  border: none;

  svg {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ${(props) =>
    props.direction === "left"
      ? css`
          left: 14%;
        `
      : css`
          right: 14%;
        `}
  top: 41%;
  z-index: 2;
  font-size: 3.2rem;

  @media (max-width: 570px){
      svg {
        display: none;
      }
    }
`;

export const Important = styled.h3`
  color: ${colors.green};
    font-size: 23px;
    margin: 77px auto;
    margin-bottom: 26px;
    text-transform: uppercase;
    max-width: 320px;
    text-align: center;

`;
export const ContentImportant = styled.div`
p{
  font-family: "Chivo", sans-serif;
  font-size: 16px;
  max-width: ${(props) => `${props.maxWidth}px` || "100%"};
  margin: 0 auto;
  margin-bottom: 48px;
  text-align: center;
  span {
    font-weight: bold;
  }
}

`;
